import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import Select from '../Select';
import Checkbox from '../Checkbox';
import Radios from '../Radios';

import {
  IMPORT_SEARCH_FIELD_TYPES,
  IMPORT_ORDER_SEARCH_FIELD_TYPES,
  IMPORT_METHODS,
} from '../../../config';

const validationSchema = Yup.object();

const getInitialValues = ({ templateType, importData, warehouses }) => {
  if (templateType === 'SKU') {
    return {
      searchField: importData.searchField || IMPORT_SEARCH_FIELD_TYPES[0].value,
      importMethod: IMPORT_METHODS[1].value,
      replacePictures: importData.replacePictures || false,
      updateRests: importData.updateRests || false,
      warehouseName: importData.warehouseName || warehouses[0] ? warehouses[0].title : '',
      clearEmptyValues: importData.clearEmptyValues || false,
    };
  }
  if (templateType === 'ORDER') {
    return {
      searchField: importData.searchField || IMPORT_SEARCH_FIELD_TYPES[0].value,
    };
  }
};

const UploadSkuSettings = (props) => {
  const { templateType, importData, handleCreateTask } = props;

  const { warehouses } = useSelector((state) => state.orders);

  const formik = useFormik({
    initialValues: getInitialValues({ templateType, importData, warehouses }),
    onSubmit: async (values) => {
      handleCreateTask(values);
    },
    validationSchema,
  });

  const { values, errors, submitCount, handleChange, handleSubmit, setFieldValue } = formik;

  const warehousesOptions = warehouses.map((w) => ({ label: w.title, value: w.title }));

  return (
    <React.Fragment>
      <div id="xls-import-step2" className="row mb-2">
        <div className="col-12">
          <div className="form-inline">
            <div className="form-group mb-3">
              <span className="number-circle mr-2">2</span>
              <span className="mr-2">Настройки загрузки</span>
            </div>
          </div>
        </div>
        <div className="col-12">
          <div className="card grey-background">
            <div className="card-body">
              {templateType === 'SKU' ? (
                <div className="row">
                  <div className="col-xl-4 col-lg-6">
                    <div className="form-group">
                      <Select
                        label="Сопоставление номенклатуры"
                        id="searchField"
                        options={IMPORT_SEARCH_FIELD_TYPES}
                        value={IMPORT_SEARCH_FIELD_TYPES.find(
                          (o) => o.value === values.searchField,
                        )}
                        onChange={({ value }) => setFieldValue('searchField', value)}
                      />
                    </div>
                    <div className="form-group">
                      <label>Режим загрузки номенклатуры</label>
                      <Radios
                        id="importMethod"
                        name="importMethod"
                        data={IMPORT_METHODS}
                        currentValue={values.importMethod}
                        onChange={(value) => setFieldValue('importMethod', value)}
                      />
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-6 pl-xl-3">
                    <div className="form-group">
                      <div className="mb-2">
                        <Checkbox
                          label="Заменить изображения"
                          id="replacePictures"
                          checked={values.replacePictures}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="mb-2">
                        <Checkbox
                          label="Загружать остатки"
                          id="updateRests"
                          checked={values.updateRests}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="mb-2">
                        <Checkbox
                          label="Стирать значения, если они пустые"
                          id="clearEmptyValues"
                          checked={values.clearEmptyValues}
                          onChange={handleChange}
                        />
                      </div>
                      <Select
                        label="Укажите склад"
                        id="warehouseName"
                        options={warehousesOptions}
                        value={warehousesOptions.find((o) => o.value === values.warehouseName)}
                        onChange={({ value }) => setFieldValue('warehouseName', value)}
                      />
                    </div>
                  </div>
                  <div className="col-lg-12" />
                </div>
              ) : null}

              {templateType === 'ORDER' ? (
                <div className="row">
                  <div className="col-xl-4 col-lg-6">
                    <div className="form-group">
                      <Select
                        label="Режим поиска товаров"
                        id="searchField"
                        options={IMPORT_ORDER_SEARCH_FIELD_TYPES}
                        value={IMPORT_ORDER_SEARCH_FIELD_TYPES.find(
                          (o) => o.value === values.searchField,
                        )}
                        onChange={({ value }) => setFieldValue('searchField', value)}
                      />
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-12">
              <div className="text-sm-right">
                <button
                  type="button"
                  className="btn btn-danger waves-effect waves-light"
                  onClick={handleSubmit}
                >
                  <i className="fe-play"></i> Обработать
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default UploadSkuSettings;
